import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import safeStorage from '@/lib/safeStorage';
import { useAuth } from '@/contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = 'smb_site_settings';

const SiteSettingsContext = createContext({});

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => safeStorage.get(CACHE_KEY) || {});

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then(r => {
        setSettings(r.data);
        safeStorage.set(CACHE_KEY, r.data);
      })
      .catch(() => {});
  }, []);

  return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}

/**
 * Prenotazioni online attive per l'utente corrente.
 * Il flag "Prenotazioni attive" (Impostazioni) blocca i pazienti e gli anonimi;
 * admin e operatori possono sempre prenotare per conto dei pazienti.
 */
export function useBookingActive() {
  const settings = useContext(SiteSettingsContext);
  const { user } = useAuth();
  const isStaff = user && (user.role === 'admin' || user.role === 'operator');
  return settings.prenotazioni_attive !== false || !!isStaff;
}

export default SiteSettingsContext;
